import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTriggerCRUDActions } from '@mm/state/actions/TriggerCRUDActions';
import { usePageCRUDActions } from '@mm/state/actions/PageCRUDActions';
import { useWidgetCRUDActions } from '@mm/state/actions/WidgetCRUDActions';
import { widgetsByDialogueSelector } from '@mm/state/selectors/widgetSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import TriggerModel from '@mm/state/model/TriggerModel';
import useRouter from 'use-react-router';
import { BotBuilderRoutes } from '../../../../routes/bot-builder-routes';

export const usePrimeState = (
  chatbotId: number,
  triggerId: number,
  dialogueId: number,
) => {
  const triggerCRUDActions = useTriggerCRUDActions();
  const pageCURDActions = usePageCRUDActions();
  const widgetCRUDActions = useWidgetCRUDActions();

  const { history } = useRouter();
  const [keywordTrigger, setKeywordTrigger] = useState<
    TriggerModel | undefined
  >();
  const [keywordDialogue, setKeywordDialogue] = useState();

  const widgets = useSelector((state: StoreState) =>
    widgetsByDialogueSelector(dialogueId, state.widget.entities),
  );

  useEffect(() => {
    const getSMSTrigger = async () => {
      const trigger = await triggerCRUDActions.retrieveById(triggerId);
      if (trigger) {
        setKeywordTrigger(trigger);

        // This is bad! BE should allow us to create active trigger. Double check with BE developer
        // about this.
        if (!trigger.active) {
          triggerCRUDActions.update({ ...trigger, active: true });
        }
      }
    };

    getSMSTrigger();
  }, []);

  useEffect(() => {
    const getDialogue = async () => {
      const dialogue = await pageCURDActions.retrieveById(dialogueId);
      if (dialogue) {
        setKeywordDialogue(dialogue);
        widgetCRUDActions.retrieveAll(dialogueId, true);
      }
    };

    getDialogue();
  }, []);

  useEffect(() => {
    const correctDialogueId = keywordTrigger?.botResponses[0]?.pageId;

    if (
      keywordTrigger &&
      correctDialogueId &&
      correctDialogueId !== Number(dialogueId)
    ) {
      const newUrl = BotBuilderRoutes.smsKeywordEdit.getLink({
        chatbotId,
        dialogueId: correctDialogueId,
        smsKeywordId: keywordTrigger.id,
      });

      newUrl && history.replace(newUrl);
    }
  }, [keywordTrigger?.botResponses[0]?.pageId, dialogueId, chatbotId]);

  return {
    keywordTrigger,
    setKeywordTrigger,
    keywordDialogue,
    widgets,
  };
};
